import {
    ROAD_BOOK_CONFIGURATION_DELETED,
    ROAD_BOOK_CONFIGURATION_DELETING,
    ROAD_BOOK_CONFIGURATION_DOWNLOADED,
    ROAD_BOOK_CONFIGURATION_FOCUS,
    ROAD_BOOK_CONFIGURATION_SENDING,
    ROAD_BOOK_CONFIGURATIONS_DOWNLOADED,
    ROAD_BOOK_CONFIGURATIONS_FAILED,
    ROAD_BOOK_CONFIGURATIONS_PENDING,
} from './types';

export const INITIAL_STATE = {
    error: null,
    content: null,
    pending: false,
    sending: false,
    deleting: false,
    currentRoadBookConfiguration: null,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ROAD_BOOK_CONFIGURATIONS_PENDING:
            return {
                ...state,
                pending: true,
            };
        case ROAD_BOOK_CONFIGURATION_SENDING:
            return {
                ...state,
                sending: true,
                currentRoadBookConfiguration: null,
            };
        case ROAD_BOOK_CONFIGURATIONS_DOWNLOADED: {
            let newContentRBC;
            if (state.content !== null) {
                newContentRBC = { ...state.content };
            } else {
                newContentRBC = {};
            }
            newContentRBC[action.payload.lang] = action.payload.roadBookConfigurations;
            let actualCurrent = state.currentRoadBookConfiguration;
            if (
                action.payload.roadBookConfigurationId !== undefined
                && action.payload.roadBookConfigurationId !== null
            ) {
                actualCurrent = action.payload.roadBookConfigurations.find(rba => rba.id
                    === action.payload.roadBookConfigurationId);
            }
            return {
                ...state,
                pending: false,
                sending: false,
                content: newContentRBC,
                currentRoadBookConfiguration: actualCurrent,
            };
        }
        case ROAD_BOOK_CONFIGURATION_DOWNLOADED: {
            let newContentRBC;
            if (state.content !== null) {
                newContentRBC = { ...state.content };
            } else {
                newContentRBC = {};
                newContentRBC[action.payload.lang] = [];
            }
            const newItem = action.payload.roadBookConfiguration;
            const index = newContentRBC[action.payload.lang].findIndex(rba => {
                return rba.id === newItem.id;
            });
            if (index !== -1) {
                newContentRBC[action.payload.lang][index] = newItem;
            } else {
                newContentRBC[action.payload.lang].push(newItem);
            }
            return {
                ...state,
                currentRoadBookConfiguration: newItem,
                pending: false,
                sending: false,
                deleting: false,
                content: newContentRBC,
            };
        }
        case ROAD_BOOK_CONFIGURATIONS_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                deleting: false,
                error: action.payload,
            };
        case ROAD_BOOK_CONFIGURATION_FOCUS:
            return {
                ...state,
                currentRoadBookConfiguration: action.payload.roadBookConfiguration,
            };
        case ROAD_BOOK_CONFIGURATION_DELETING:
            return {
                ...state,
                deleting: true,
            };
        case ROAD_BOOK_CONFIGURATION_DELETED:
            let newContent = { ...state.content };
            const index = newContent[action.payload.lang].findIndex(rba => {
                return rba.id === action.payload.roadBookConfiguration.id;
            });
            if (index !== -1) {
                newContent[action.payload.lang].splice(index, 1);
            }
            let newCurrent = { ...state.currentRoadBookConfiguration };
            if (newCurrent.id === action.payload.roadBookConfiguration.id) {
                newCurrent = null;
            }
            return {
                ...state,
                deleting: true,
                content: newContent,
                currentRoadBookConfiguration: newCurrent
            };
        default:
            break;
    }
    return state;
}



// WEBPACK FOOTER //
// src/store/roadBookConfigurations/reducers.js